export class Admin {
    id: number;
    full_name: string;
    userName: string;
    email: string;
    phone: string;
    password: string;
    device_id: number;
    base_path?: string;
}